import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-161e801e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "inquiry-feed"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-consult"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "咨询", -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divdier"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-feedback"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "反馈", -1));
const _hoisted_8 = [_hoisted_6, _hoisted_7];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_joinus_form = _resolveComponent("joinus-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_client_only = _resolveComponent("client-only");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "feedback-button",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.openForm && _ctx.openForm(...args))
  }, _hoisted_4), _hoisted_5, _createElementVNode("div", {
    class: "feedback-button",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.openFeed && _ctx.openFeed(...args))
  }, _hoisted_8), _createVNode(_component_client_only, null, {
    default: _withCtx(() => [_createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.dialogVisible = $event),
      "modal-class": "inquiry-form-dialog",
      width: "488px"
    }, {
      default: _withCtx(() => [_createVNode(_component_joinus_form, {
        logtype: "fix",
        "close-toast": true,
        onSubmitFormSuccess: _ctx.submitSuccess
      }, null, 8, ["onSubmitFormSuccess"])]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  })]);
}